import {useTranslation} from 'react-i18next';
import {Authorize} from '@postinumero/authorization';
import Page from '../../Page';
import Forbidden from '../Forbidden';
import Layout from './Layout'

export default function Tariffs() {
  const [t] = useTranslation();

  return (
    <Page title={t("reusables.title")}>
      <Authorize allow={['Issuer agent', 'Account operator', 'Inspector', 'Administrator']} fallback={<Forbidden/>}>
        <Layout/>
      </Authorize>
    </Page>
  );
}
